import styled, { css } from 'styled-components';

export const ExplorerWrapper = styled.section`
  width: 20vw;
  min-width: 280px;
  max-width: 320px;
  flex: 0 0 20vw;
  box-sizing: border-box;
  padding: 4px 16px 16px 24px;
  opacity: ${(props) => (props.$isVisible ? 1 : 0)};
  transition: opacity 0.3s ease;
  pointer-events: ${(props) => (props.$isOpen ? 'auto' : 'none')};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  
  /* overflow: auto; */
  // background-color: ${(props) => props.theme.colors.black};
  overflow-y: auto;
  overflow-x: hidden; //    .----------
  scrollbar-color: auto;
  scrollbar-width: auto;

  @supports not selector(::-webkit-scrollbar-thumb) {
    scrollbar-color: #525d65 #101315;
  }

  &::-webkit-scrollbar {
    width: 14px;
  }

  &::-webkit-scrollbar-track {
    background-color: #101315;
  }

  &::-webkit-scrollbar-button {
    display: none;
    width: 0;
    height: 0;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: linear-gradient(180deg, #525d65 0%, #424d55 35%, #293539 100%) !important;
    border: 2px solid #101315;
  }
  z-index: 999;
  background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgba(17, 20, 23, 1) 60%, rgba(17, 20, 23, 1) 100%);

  @media screen and (max-width: ${(props) => props.theme.sizes.tablet}) {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    overflow-y: auto;
    overflow-x: hidden;
    padding: ${(props) => (props.$isOpen ? '2rem' : '2rem 0')};
    width: 40%;
    min-width: 0;
    flex: none;
    max-width: 320px;
    height: 100%;
    background: linear-gradient(90deg, ${(props) => props.theme.colors.black} 0%, ${(props) => `${props.theme.colors.black}EF 100%`});
    border-right: #666 1px solid;
    box-shadow: 10px 10px 50px #111;
    transform: translateX(${(props) => (props.$isOpen ? '0' : '-100%')});
    opacity: 1;
    transition: transform 0.3s ease, padding 0.3s ease;
  }
`;

export const CloseButton = styled.div`
  align-self: flex-start;
  cursor: pointer;
  color: white;
  height: 20px;
  width: 20px;
`;

export const ExplorerNavbar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ExplorerHeader = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: start;

  /* padding: 0.5em 0.5em 3em 0.5em; */
  padding: .75em;
  color: ${(props) => props.theme.colors.smokeWhite};
  font-size: ${(props) => props.theme.font.size.medium};

  @media screen and (max-width: ${(props) => props.theme.sizes.desktop}) {
    padding: 1em 0 1em 0;
    align-self: flex-start;
  }
`;

export const VersionNumber = styled.span`
  color: #FFFFFF1A;
  width: 100%;
  font-size: 0.625em;
  text-align: start;
  align-self: start;
  transition: color 0.1s ease;
  cursor: default;
  &:hover {
    color: #5b84fc8f;
    transition: color 0.3s ease;
  }
`;

export const StyledExplorerList = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  font-size: ${(props) => props.theme.font.size.small};
  color: ${(props) => props.theme.colors.smokeWhite};
`;

export const StudyList = styled.div`
  border-left: 1px solid #f5f5f5;
  transition: border-left 0.16s ease;

  & :hover {
    // border-left: ${(props) => props.currentTab !== 'current' && '12px solid #f5f5f5'};
    border-left: 12px solid #f5f5f5;
    transition: border-left 0.16s ease;
  }

  & :hover * {
    border-left: 0 solid #f5f5f5;
    transition: border-left 0.16s ease;
    // border-left: ${(props) => props.currentTab !== 'current' && 'none'};
  }
`;

export const SeriesWrapper = styled.div`
  min-height: 100%;
  overflow: auto;
`;

export const SeriesItemWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  @media screen and (max-width: ${(props) => props.theme.sizes.mobile}) {
    flex-direction: column;
  }
  padding: 4px 2px 4px 8px;
  color: ${(props) => props.theme.colors.smokeWhite};
  cursor: pointer;

  /* background-color: ${(props) => props.theme.colors.black}; */
  background-color: ${(props) => (props.selected ? '#353535' : 'none')};

  border-left: ${(props) => (props.selected ? '6px solid #536878' : 'none')};

  :hover {
    /* background-color: ${(props) => (props.selected ? '#151515' : 'none')}; */
    background-color: #36454f;
  }
`;

export const StudyItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2% 1% 2% 6%;
  cursor: pointer;
  width: 100%;

  // border-left: 1px solid #f5f5f5;
  // border-left: ${(props) => (props.selected ? '6px solid #f5f5f5' : 'none')};
  // border-left: ${(props) => props.currentTab !== 'current' && (props.selected ? '6px solid #f5f5f5' : 'none')};
`;

export const ItemDetailsWrapper = styled.div`
  width: 100%;
  padding-left: 1em;
`;

export const ExplorerName = styled.div`
  font-weight: ${(props) => props.theme.font.weight.medium};
  word-break: break-all;
  font-size: 1em;
  font-size: ${(props) => props.theme.font.size.small};
  color: ${(props) => (props.selected === true ? props.theme.colors.white : props.theme.colors.greyWhite)};
`;

const SeriesDetailsBase = css`
  font-weight: ${(props) => props.theme.font.weight.light};
  font-size: ${(props) => props.theme.font.size.ultrasmaller};
`;

export const ExplorerSummary = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: start;
  color: ${(props) => props.theme.colors.greyWhite};

  ${SeriesDetailsBase}
`;

export const Thumbnail = styled.img`
  width: 120px;
  height: 80px;
  object-fit: cover;
  min-height: 4%;
  /* height: 100px; */

  margin: 0;
  box-sizing: border-box;

  background-color: ${(props) => props.theme.colors.black};

  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
`;

export const ThumbnailLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  /* height: 100%; */
  color: ${(props) => props.theme.colors.smokeWhite};
  font-size: 12px;
`;

export const PlaceholderThumbnail = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 0 auto;
  box-sizing: border-box;
  background-color: ${(props) => props.theme.colors.black};
  color: ${(props) => props.theme.colors.greyWhite};
`;

export const StyledTabsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-self: flex-start;
  cursor: pointer;
  position: relative;
  width: 100%;
  :after {
    position: absolute;
    content: '';
    width: 100%;
    bottom: 0;
    left: 0;
    border-bottom: 1px solid ${(props) => props.theme.colors.smokeWhite};
    z-index: 1;
  }
`;

export const StyledTab = styled.div`
  border: 1px solid ${(props) => props.theme.colors.grayBlackShadow};
  border-radius: 4px 4px 0 0;
  margin: 0;
  padding: 4px 44px;
  color: ${(props) => props.theme.colors.grayBlackShadow};

  &.selected {
    /* box-shadow: 0 3px 3px rgba(0, 0, 0, 0.4), inset 0 1px 0 #fff; */
    border: 1px solid ${(props) => props.theme.colors.smokeWhite};
    color: ${(props) => props.theme.colors.smokeWhite};
    z-index: 2;
    border-bottom-color: ${(props) => props.theme.colors.black};
  }
`;

export const ShowExplorerTabContent = styled.div`
  @media screen and (max-width: ${(props) => props.theme.sizes.desktop}) {
    height: 48px;
    width: 20px;
    background-color: #000000;
    opacity: 0.8;
    border: 1px solid #FFFFFF;
    border-left: none;
    border-radius: 0px 5px 5px 0px;
    writing-mode: vertical-rl;
    text-orientation: upright;
    color: white;
    letter-spacing: -4px;
    font-size: 12px;
  }
`;
export const ShowExplorerTabBox = styled.div`
  @media screen and (max-width: ${(props) => props.theme.sizes.desktop}) {
    z-index: 999;
    position: fixed;
    top: 10%;
    transform: translateY(-50%);
    padding: 15px 30px 15px 0px;
    transition: top 0.3s;
  }
  @media screen and (max-width: ${(props) => props.theme.sizes.tablet}) {
    &.show-explorer {
      margin-left: 40%;
      top: 10%;
    }
  }
`;
